// Generated file; do not edit. See https://github.com/stencila/stencila/tree/main/rust/schema-gen

export type InlineType =
  | "AudioObject"
  | "Button"
  | "Cite"
  | "CiteGroup"
  | "CodeExpression"
  | "CodeInline"
  | "Date"
  | "DateTime"
  | "DeleteInline"
  | "Duration"
  | "Emphasis"
  | "ImageObject"
  | "InsertInline"
  | "InstructionInline"
  | "Link"
  | "MathInline"
  | "MediaObject"
  | "ModifyInline"
  | "Note"
  | "Parameter"
  | "QuoteInline"
  | "ReplaceInline"
  | "StyledInline"
  | "Strikeout"
  | "Strong"
  | "Subscript"
  | "Superscript"
  | "Text"
  | "Time"
  | "Timestamp"
  | "Underline"
  | "VideoObject"
  | "Null"
  | "Boolean"
  | "Integer"
  | "UnsignedInteger"
  | "Number";

export const InlineTypeList = [
  "AudioObject",
  "Button",
  "Cite",
  "CiteGroup",
  "CodeExpression",
  "CodeInline",
  "Date",
  "DateTime",
  "DeleteInline",
  "Duration",
  "Emphasis",
  "ImageObject",
  "InsertInline",
  "InstructionInline",
  "Link",
  "MathInline",
  "MediaObject",
  "ModifyInline",
  "Note",
  "Parameter",
  "QuoteInline",
  "ReplaceInline",
  "StyledInline",
  "Strikeout",
  "Strong",
  "Subscript",
  "Superscript",
  "Text",
  "Time",
  "Timestamp",
  "Underline",
  "VideoObject",
  "Null",
  "Boolean",
  "Integer",
  "UnsignedInteger",
  "Number",
];
